var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user !== null)?_c('div',{staticClass:"UserDetails"},[_vm._v("\n    Welcome "+_vm._s(_vm.user.name)+"\n\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }